// extracted by mini-css-extract-plugin
export default {"ticketLink":"TicketLink_ticketLink__Gg6uG","ticketWrapper":"TicketLink_ticketWrapper__azsvI","linkText":"TicketLink_linkText__pblbd"};